import Icon from 'components/base/Icon';
import { Flex, Margin } from 'components/base/layout-components';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { PDT_PAGE_SIZE, PDT_PAGE_SIZE_OPTIONS } from '../projects.consts';
import Dropdown from 'components/base/Dropdown';

const StyledIcon = styled(Icon)`
  :hover {
    cursor: pointer;
  }
`;

export const PaginationSection = ({ total = 0, paginationHandler = {} }) => {
  const {
    page,
    setPage,
    pageSize = PDT_PAGE_SIZE,
    setPageSize
  } = paginationHandler;
  const firstItemInPageIndex = page * pageSize - pageSize + 1;
  const lastItemInPageIndex = page * pageSize;
  const isOnLastPage = lastItemInPageIndex >= total;

  return (
    <Flex
      direction='row'
      justify='right'
      items='center'
      data-cy='pagination-section'
    >
      <Margin r='medium'>
        <Text size='large' color='shuttleGray'>
          Rows per page:{' '}
        </Text>
      </Margin>
      <Margin r='x-medium'>
        <Dropdown
          options={PDT_PAGE_SIZE_OPTIONS}
          width='3rem'
          selectedValue={pageSize}
          onChange={option => {
            setPage(1);
            setPageSize(option);
          }}
          data-cy='per-page-dropdwon'
        />
      </Margin>
      <Margin r='x-medium'>
        <Text size='large' color='shuttleGray'>
          {!total ? 0 : firstItemInPageIndex} -{' '}
          {Math.min(lastItemInPageIndex, total)} of {total}
        </Text>
      </Margin>
      <Margin r='medium'>
        <StyledIcon
          name='ChevronLeft'
          onClick={() => (page > 1 ? setPage(page - 1) : null)}
          color={page === 1 ? 'osloGray' : 'black'}
        />
      </Margin>
      <Margin r='medium'>
        <StyledIcon
          name='ChevronRight'
          onClick={() => (!isOnLastPage ? setPage(page + 1) : null)}
          color={isOnLastPage ? 'osloGray' : 'black'}
        />
      </Margin>
    </Flex>
  );
};
